import { useHover } from '@uidotdev/usehooks';
import { Edit2, Trash } from 'iconsax-react';
import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { IItem, IItemLocalize, IModalVisible } from 'utils/types/storyTypes';

interface IProps {
  textIndex: number; // 텍스트 인덱스

  visibleState: IModalVisible; // 팝업 활성, 비활성 정보
  setVisibleState: React.Dispatch<React.SetStateAction<IModalVisible>>;
  setTextIndex: React.Dispatch<React.SetStateAction<number>>;
}

// 다국어 지원 테이블 액션아이템
const ActionItems: React.FC<IProps> = ({
  textIndex, // array 접근용

  visibleState,
  setVisibleState,
  setTextIndex, // 텍스트 인덱스 변경용도! (edit 에게 전달하기 위함)
}) => {
  const [editRef, editHovering] = useHover<HTMLDivElement>();
  // const [removeRef, removeHovering] = useHover<HTMLDivElement>();

  const handleDelete = () => {
    // const cloneData = JSON.parse(JSON.stringify(data));
    // cloneData.localizations.splice(i, 1);
    // setData(cloneData);
  };

  return (
    <>
      <IconWrapper
        ref={editRef}
        style={{
          color: editHovering ? theme.colors.blue_500 : theme.colors.dark_200,
        }}
      >
        <Edit2
          size='24'
          onClick={() => {
            // 선택행을 변경해준다
            setTextIndex(textIndex);

            // visible을 변경해주고
            setVisibleState({ ...visibleState, edit: true });
          }}
        />
      </IconWrapper>
      {/* <IconWrapper
        ref={removeRef}
        style={{
          color: removeHovering ? theme.colors.red_500 : theme.colors.dark_200,
        }}
      >
        <Trash size='24' onClick={handleDelete} />
      </IconWrapper> */}
    </>
  );
};

export default ActionItems;

const IconWrapper = styled.div`
  cursor: pointer;
`;
